import { MessageCircle } from 'lucide-react';
import { useState } from 'react';

const WhatsAppFloatingButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const phoneNumber = '91795641';
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <div className="fixed bottom-6 left-6 z-50">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="flex items-center gap-3 bg-primary text-primary-foreground rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 animate-fade-in group"
        aria-label="تواصل مع خدمة العملاء عبر الواتساب"
      >
        <div className="flex items-center justify-center w-12 h-12 rounded-full">
          <MessageCircle className="w-6 h-6" />
        </div>
        <div 
          className={`overflow-hidden transition-all duration-300 ${
            isHovered ? 'max-w-xs opacity-100 pr-4' : 'max-w-0 opacity-0'
          }`}
        >
          <p className="text-sm font-medium whitespace-nowrap">خدمة العملاء</p>
        </div>
      </a>
    </div>
  );
};

export default WhatsAppFloatingButton;
